import { ShowById } from "src/components/ShowById";
import { useParams } from "react-router-dom";

export function ShowDeviationById() {
  const { deviationId } = useParams();
  return <ShowById id={deviationId || ""} />;
}
